import React from 'react'
import type { TrackTextSettings } from 'types/business'
import type { Track } from 'types/track'
import TrackCaptionItem from './TrackCaptionItem'
const SEPARATOR = ': '
type Props = {
  settings?: TrackTextSettings
  track: Track
  artistUrl?: string | null | undefined
  albumUrl?: string | null | undefined
  onAlbumClick?: (id: Track['album_id']) => void
  onArtistClick?: (id: Track['artist_id']) => void
}

const TrackCaption = ({
  settings,
  track,
  artistUrl,
  albumUrl,
  onAlbumClick,
  onArtistClick,
}: Props) => {
  if (settings === 'title_composer_description' && track.metadata) {
    return (
      <TrackCaptionItem
        content={[track.metadata['Composer'], track.metadata['Description']]
          .filter(Boolean)
          .join(SEPARATOR)}
        id={track.artist_id}
        url={artistUrl}
        onClick={onArtistClick}
      />
    )
  }

  return (
    <>
      <TrackCaptionItem
        content={track.artist}
        id={track.artist_id}
        url={artistUrl}
        onClick={onArtistClick}
      />
      {track.artist && track.album && SEPARATOR}
      <TrackCaptionItem
        content={track.album}
        id={track.album_id}
        url={albumUrl}
        onClick={onAlbumClick}
      />
    </>
  )
}

export default React.memo<Props>(TrackCaption)
